import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { fetchAllData } from "../actions/CSVActions";
import { API_URL } from "../../utils/constants";

class CSVComponent extends Component {
  handleDownload = () => {
    // Build URL for streaming
    let csvUrl = this.props.url;
    if (csvUrl.includes("?")) csvUrl += "&stream_csv=1";
    else csvUrl += "?stream_csv=1";

    // Use the same mapper/sorter logic, but if stream mode, bypass Redux call
    this.props.fetchAllData(
      csvUrl,
      this.props.csvName,
      this.props.mapper,
      this.props.sorter
    );
  };

  render() {
    return (
      <button
        type="button"
        className="btn btn-outline-secondary"
        onClick={this.handleDownload}
      >
        CSV <span className="glyphicon glyphicon-download-alt"></span>
      </button>
    );
  }
}

function mapStateToProps(state) {
  return {
    CSVInfo: state.CSVInfo.CSVInfo,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      fetchAllData,
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(CSVComponent);
